<template>
  <div ref="pieChartRef" class="w-full h-full"></div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import * as echarts from "echarts";

export default {
  name: "PieChartComponent",
  props: {
    data: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const pieChartRef = ref(null);

    const initChart = () => {
      const chart = echarts.init(pieChartRef.value);

      const option = {
        tooltip: {
          //trigger: 'item',
        },
        legend: {
          bottom: "16%", // Move legend to the bottom
          left: "left", // Align legend to the left
          orient: "vertical",
          //top: "5%",
          // left: "right",
          textStyle: {
            color: "#475467",
          },
          formatter: (name) => {
            const total = props.data.reduce((sum, item) => sum + item.value, 0); // Calculate the total value
            const item = props.data.find((d) => d.name === name); // Find the legend item
            const percentage = Math.round((item.value / total) * 100); // Calculate percentage as an integer

            return `${name}: ${percentage ? percentage : 0}%`; // Display the legend name and integer percentage
          },
        },
        series: [
          {
            type: "pie",
            radius: ["25%", "50%"],
            center: ["50%", "25%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
            },
            data: props.data,
            itemStyle: {
              color(params) {
                const colors = ["#ABEFC6", "#FDA29B", "#73E2A3"];
                return colors[params.dataIndex];
              },
            },
          },
        ],
      };

      chart.setOption(option);

      chart.on('click', (params) => {
        emit('learnerTaskCompletionStatus', params);
      });
    };

    onMounted(() => {
      initChart();
    });

    watch(
      () => props.data,
      () => {
        initChart();
      }
    );

    return {
      pieChartRef,
    };
  },
};
</script>